// @flow
import React, { Component } from 'react';
import { Checkbox, FormGroup, Collapse } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import RadioStation from './components/RadioStation/RadioStation';
import isEqual from '../../util/compareRadioObject';

import style from './style';

class RadioStationsGroup extends Component<{
  radioGroup: Object,
  checkedStations: Array<Object>,
  onChange: Function,
}, {open: boolean}> {

  constructor(props: Object) {
    super(props);

    this.state = {
      open: false,
      radioStations: this.props.radioGroup,
    };
  }

  onStationCheckedChange(data: Object, state: boolean) {
    this.props.onChange([{ data, state }]);
  }

  onRadioGroupChange(state: boolean) {
    const list = this.props.radioGroup.radios.map(e => ({ data: e, state }));
    this.props.onChange(list);
  }

  toggleCollapse() {
    this.setState({ open: !this.state.open });
  }

  allStationsAreChecked(): boolean {
    const checkedStations = this.props.checkedStations;
    return this.props.radioGroup.radios.every((e: Object) => checkedStations.some(r => isEqual(r, e)));
  }

  stationsAreMixedChecked(): boolean {
    const checkedStations = this.props.checkedStations;
    const radios = this.props.radioGroup.radios;
    const firstRadioState = checkedStations.some(r => isEqual(r, radios[0]));
    return radios.every((e: Object) => checkedStations.some(r => isEqual(r, e)) === firstRadioState) === false;
  }

  generateStationList(): React.Element<any> {
    const list = [];
    const checkedStations = this.props.checkedStations;

    this.props.radioGroup.radios.forEach((radio) => {
      const radioIsChecked = checkedStations.some(r => isEqual(r, radio));
      list.push(
        <RadioStation
          radioData={radio}
          key={radio.title}
          value={radioIsChecked}
          onChange={(n: object, s: boolean) => this.onStationCheckedChange(n, s)}
        />,
      );
    });

    return list;
  }

  render() {
    const iconName = (this.state.open) ? 'caret-down' : 'caret-right';

    return (<div style={style.content}>
      <FormGroup style={style.formGroup}>
        <FontAwesome name={iconName} style={style.toggle} onClick={() => this.toggleCollapse()} />
        <Checkbox
          inline
          style={style.checkbox}
          checked={this.allStationsAreChecked()}
          onChange={(event: Object) => this.onRadioGroupChange(event.target.checked)}
          inputRef={(r) => { if (r != null) r.indeterminate = this.stationsAreMixedChecked(); }}
        >
          {this.props.radioGroup.country}
        </Checkbox>
      </FormGroup>
      <Collapse in={this.state.open}>
        <div style={style.list}>
          {this.generateStationList()}
        </div>
      </Collapse>

    </div>);
  }
}

export default RadioStationsGroup;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Radio/components/RadioStationsGroup/RadioStationsGroup.js